import { render, staticRenderFns } from "./ProductsPromotionEdit.vue?vue&type=template&id=51e428ed&"
import script from "./ProductsPromotionEdit.vue?vue&type=script&lang=js&"
export * from "./ProductsPromotionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports